module.exports = __webpack_public_path__ + "img/IF.88349143.png";